import './CSS/Footer.css';

/**
 * フッターのコンポーネントです。
 * @returns  React.FunctionComponent
 */
const Footer: React.FC = () => {
    return (
        <footer>
            <div>Copyright,2022 Quick IoT</div>
        </footer>
    );
};

export default Footer;
